/** @format */

export const useSelectA11y = () => {
    const getRootProps = () => ({
        role: 'listbox',
    });

    const getToggleButtonProps = (
        isOpen: boolean,
        closeMenuAriaLabel: string,
        openMenuAriaLabel: string
    ) => ({
        'aria-label': isOpen ? closeMenuAriaLabel : openMenuAriaLabel,
        'aria-haspopup': true,
    });

    const getLabelProps = (id: string) => ({
        id: `${id}-label`,
    });

    const getMenuProps = (id: string) => ({
        id: `${id}-menu`,
        role: 'listbox',
        'aria-labelledby': `${id}-label`,
    });

    const getItemProps = ({ isSelected, ...others }: any) => ({
        role: 'option',
        'aria-selected': isSelected,
        ...others,
    });

    return {
        getRootProps,
        getToggleButtonProps,
        getLabelProps,
        getMenuProps,
        getItemProps,
    };
};
